import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { COMMON_API } from "../../commonAPI";

const AddMission = () => {
  const navigate = useNavigate();
  const token = sessionStorage.getItem("authToken");
  const [description, setDescription] = useState("");
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);

  const handleFileChange = (e) => {
    const selected = e.target.files[0];
    setFile(selected);
    if (selected) setPreview(URL.createObjectURL(selected));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const fd = new FormData();
      fd.append("description", description);
      if (file) fd.append("image", file);

      const res = await axios.post(`${COMMON_API}/loan/addMission`, fd, {
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
      });

      if (res.data.success) {
        alert("Mission added successfully!");
        navigate("/mission");
      }
    } catch (err) {
      console.error("Error adding mission:", err);
      alert("Failed to add mission.");
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <div className="max-w-3xl mx-auto bg-white shadow-lg rounded-2xl p-6">
        <h2 className="text-2xl font-bold mb-4">Add Mission</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="text"
            placeholder="Description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            className="w-full border px-3 py-2 rounded"
            required
          />
          <div>
            <label className="block text-sm font-semibold">Image</label>
            {preview && <img src={preview} alt="Preview" className="w-48 h-32 rounded mb-2" />}
            <input type="file" accept="image/*" onChange={handleFileChange} required />
          </div>
          <button type="submit" className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700">
            Add Mission
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddMission;
